import { host } from "config/api.config";
import { Area } from "model/area.model";
import { GetAreaDTO } from "model/area/getArea.model";
import { ListArea } from "model/area/listArea.model";
import { useHTTPClient } from "services/httpClient.service";

const url = `${host}/area`

export function useGetAreasApi(_companyUsername?: string, _buildingId?: string | string[], _disable?: boolean){

    const {data, loading, error, get} = useHTTPClient<ListArea[]>(url)

    function getApi(filter?: {companyUsername?:string, buildingId?: string | string[], disable?: boolean}){

        const {companyUsername, buildingId, disable} = filter ?? {}
        return get({_url: url, params: {companyUsername: companyUsername ?? _companyUsername, buildingId: buildingId ?? _buildingId, disable: disable !== undefined ? disable : _disable}})
    }

    return {
        loading,
        error,
        get: getApi,
        data
    }
}

export function useGetAreaApi(areaId: string){

    const {data, loading, error, get} = useHTTPClient<GetAreaDTO>(`${url}/${areaId}`)

    function getApi(){
        return get({})
    }

    return {
        loading,
        error,
        get: getApi,
        data
    }
}

export function useSaveNewAreaApi(){
    const {loading, error, post } = useHTTPClient<Area>(`${url}`)

    async function save(data: Omit<Area, 'id'>){
        return await post({data: data})
    }

    return {
        loading,
        error,
        save
    }
}

export function useUpdateAreaApi(id: string){
    const {loading, error, put } = useHTTPClient<Partial<Area>>(`${url}/${id}`)

    async function save(data: Partial<Area>){
        return await put({data: data})
    }

    return {
        loading,
        error,
        save
    }
}